/**
 * AMD Module + commonjs dependency management
 *
 */

define(function(require) {
	/**
	 * static inclues
	 *
	 */
    var $ = require('jquery');
    
    require("../lib/slick.min.js");



    /**
	 * private functions
	 *
	 */
    var thisObject = this;






	/**
	 * public functions
	 *
	 */
    var self = {};

    self.slick = function(selector){
        const slickInduvidual = $(selector); // jQuery
        const isProjects = slickInduvidual.hasClass('slick-slider--projects');

        slickInduvidual.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            slickInduvidual.next().find('.containerSlickPageCount').text(i + '/' + slick.slideCount);
        });


        slickInduvidual.slick({
            // slide: '.slick-slide',
            infinite: true,
            slidesToShow: isProjects ? 1 : 2,
            slidesToScroll: isProjects ? 1 : 2,
            arrows: true,
            dots: false,
            appendArrows: slickInduvidual.next().find('.containerSlickNav'),
            appendDots  : slickInduvidual.next().find('.containerSlickDots'),
            prevArrow   : '<div class="slick-prev slick-arrow" aria-label="Previous">'+
            '<svg xmlns="http://www.w3.org/2000/svg" width="90.78" height="163.41" viewBox="0 0 90.78 163.41"><path class="cls-1" d="M87.22,3.51,7.2,84.67a.59.59,0,0,1,.11.1l79.75,75"/></svg>'+
            '</div>',
            nextArrow   : '<div class="slick-next slick-arrow" aria-label="Next">'+
            '<svg xmlns="http://www.w3.org/2000/svg" width="90.73" height="163.41" viewBox="0 0 90.73 163.41"><path class="cls-1" d="M3.72,3.64l79.75,75,.11.1-80,81.16"/></svg>'+
            '</div>',

            autoplay    : true,
            autoplaySpeed: 600000,
            pauseOnFocus : false,
            pauseOnHover : false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
            // slide       : '.slick-slide',
            // infinite    : true,
            // // centerMode  : true,
            // // fade        : false,
            // slidesToShow: 1,
            // // slidesToScroll: 2,
            // // variableWidth: true,
            // arrows      : true,
            // dots        : false,
            // appendArrows: slickInduvidual.find('.containerSlickNav'),
            // appendDots  : slickInduvidual.find('.containerSlickDots'),
            // prevArrow   : '<div class="slick-prev slick-arrow" aria-label="Previous">'+
            // '<svg xmlns="http://www.w3.org/2000/svg" width="90.78" height="163.41" viewBox="0 0 90.78 163.41"><path class="cls-1" d="M87.22,3.51,7.2,84.67a.59.59,0,0,1,.11.1l79.75,75"/></svg>'+
            // '</div>',
            // nextArrow   : '<div class="slick-next slick-arrow" aria-label="Next">'+
            // '<svg xmlns="http://www.w3.org/2000/svg" width="90.73" height="163.41" viewBox="0 0 90.73 163.41"><path class="cls-1" d="M3.72,3.64l79.75,75,.11.1-80,81.16"/></svg>'+
            // '</div>',
            
            // // draggable   : false,
            // autoplay    : true,
            // autoplaySpeed: 6000,
            // pauseOnFocus : false,
            // pauseOnHover : false,
            // // adaptiveHeight: true,
            // // mobileFirst: true,

            // responsive: [
            //     {
            //         breakpoint: 992,
            //         settings: {
            //             slidesToShow: 1,
            //             slidesToScroll: 1
            //             // fade        : false,
            //             // centerMode  : true,
            //             // centerPadding: '17px'
            //         }          
            //     }
            // ]
          });
    };


    /**
	 * do stuff
	 *
	 */

    const sliderNodes = document.querySelectorAll('.slick-slider');
    [...sliderNodes].forEach( element => {
        self.slick( element );
    });
    
    // self.slick( $('.slick-slider') );
    return self;
});



//////////////////
// WEBPACK FOOTER
// ./chunk/slider__slick.js
// module id = 9
// module chunks = 0